const socialPracticeReport = [{
  path: 'socialPracticeReport/index',
  component: resolve => require(['../../../../components/pages/studentresults/socialPracticeReport'], resolve)
}, {
  path: 'socialPracticeReport/upload',
  component: resolve => require(['../../../../components/pages/studentresults/socialPracticeReport/upload'], resolve)
}]
export default socialPracticeReport
